import { render, staticRenderFns } from "./konfortify-card-basic.vue?vue&type=template&id=8e1f5328&scoped=true&"
import script from "./konfortify-card-basic.vue?vue&type=script&lang=js&"
export * from "./konfortify-card-basic.vue?vue&type=script&lang=js&"
import style0 from "./konfortify-card-basic.vue?vue&type=style&index=0&id=8e1f5328&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e1f5328",
  null
  
)

export default component.exports